package br.com.vvrefeicoes.portal.feature.users

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Switch
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.di.rememberSessionPermissions
import br.com.vvrefeicoes.portal.core.ui.components.AppBadge
import br.com.vvrefeicoes.portal.core.ui.components.AppButton
import br.com.vvrefeicoes.portal.core.ui.components.AppFooter
import br.com.vvrefeicoes.portal.core.ui.components.AppModalCard
import br.com.vvrefeicoes.portal.core.ui.components.AppPagination
import br.com.vvrefeicoes.portal.core.ui.components.AppTextField
import br.com.vvrefeicoes.portal.core.ui.components.AppTooltipText
import br.com.vvrefeicoes.portal.core.ui.components.EmptyState
import br.com.vvrefeicoes.portal.core.ui.components.PortalButtonVariant
import br.com.vvrefeicoes.portal.core.ui.components.SearchableSelect
import br.com.vvrefeicoes.portal.core.ui.layout.AppScrollColumn
import br.com.vvrefeicoes.portal.core.ui.theme.AppPalette
import br.com.vvrefeicoes.portal.core.ui.theme.AppShapes
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import br.com.vvrefeicoes.portal.domain.model.Permission
import br.com.vvrefeicoes.portal.domain.model.PermissionAction
import br.com.vvrefeicoes.portal.domain.model.PermissionKeys
import br.com.vvrefeicoes.portal.domain.model.UserAccount
import br.com.vvrefeicoes.portal.domain.model.UserProfile
import br.com.vvrefeicoes.portal.domain.model.allows
import br.com.vvrefeicoes.portal.navigation.OrgChartRoute
import com.composables.icons.lucide.Ban
import com.composables.icons.lucide.Check
import com.composables.icons.lucide.Download
import com.composables.icons.lucide.EllipsisVertical
import com.composables.icons.lucide.Eye
import com.composables.icons.lucide.Folder
import com.composables.icons.lucide.KeyRound
import com.composables.icons.lucide.Lucide
import com.composables.icons.lucide.Pencil
import com.composables.icons.lucide.Plus
import com.composables.icons.lucide.Search
import com.composables.icons.lucide.ShieldCheck
import com.composables.icons.lucide.Trash2
import com.composables.icons.lucide.Upload
import com.composables.icons.lucide.UserPlus
import com.composables.icons.lucide.UserRound
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.users_action_activate
import portalvv.shared.generated.resources.users_action_create
import portalvv.shared.generated.resources.users_action_deactivate
import portalvv.shared.generated.resources.users_action_details
import portalvv.shared.generated.resources.users_action_edit
import portalvv.shared.generated.resources.users_action_view
import portalvv.shared.generated.resources.users_add
import portalvv.shared.generated.resources.users_cancel
import portalvv.shared.generated.resources.users_col_actions
import portalvv.shared.generated.resources.users_col_company
import portalvv.shared.generated.resources.users_col_email
import portalvv.shared.generated.resources.users_col_full_name
import portalvv.shared.generated.resources.users_col_last_access
import portalvv.shared.generated.resources.users_col_role
import portalvv.shared.generated.resources.users_col_updated_at
import portalvv.shared.generated.resources.users_col_updated_by
import portalvv.shared.generated.resources.users_company_hint
import portalvv.shared.generated.resources.users_deactivate_confirm
import portalvv.shared.generated.resources.users_deactivate_msg
import portalvv.shared.generated.resources.users_deactivate_title
import portalvv.shared.generated.resources.users_details_title
import portalvv.shared.generated.resources.users_empty
import portalvv.shared.generated.resources.users_export
import portalvv.shared.generated.resources.users_field_email
import portalvv.shared.generated.resources.users_field_full_name
import portalvv.shared.generated.resources.users_field_new_password
import portalvv.shared.generated.resources.users_field_permissions
import portalvv.shared.generated.resources.users_field_phone
import portalvv.shared.generated.resources.users_field_profile
import portalvv.shared.generated.resources.users_field_role
import portalvv.shared.generated.resources.users_field_sector
import portalvv.shared.generated.resources.users_form_add_title
import portalvv.shared.generated.resources.users_form_edit_title
import portalvv.shared.generated.resources.users_go_to_org_chart
import portalvv.shared.generated.resources.users_import
import portalvv.shared.generated.resources.users_inactive
import portalvv.shared.generated.resources.users_manage_permissions
import portalvv.shared.generated.resources.users_manage_profiles
import portalvv.shared.generated.resources.users_more_names
import portalvv.shared.generated.resources.users_never
import portalvv.shared.generated.resources.users_none
import portalvv.shared.generated.resources.users_only_active
import portalvv.shared.generated.resources.users_permission_code
import portalvv.shared.generated.resources.users_permission_edit_title
import portalvv.shared.generated.resources.users_permission_new
import portalvv.shared.generated.resources.users_permission_profiles
import portalvv.shared.generated.resources.users_permission_remove
import portalvv.shared.generated.resources.users_permission_remove_confirm
import portalvv.shared.generated.resources.users_permission_remove_msg
import portalvv.shared.generated.resources.users_permission_remove_title
import portalvv.shared.generated.resources.users_permissions_empty
import portalvv.shared.generated.resources.users_permissions_title
import portalvv.shared.generated.resources.users_profile_form_add_title
import portalvv.shared.generated.resources.users_profile_form_edit_title
import portalvv.shared.generated.resources.users_profile_name
import portalvv.shared.generated.resources.users_profile_new
import portalvv.shared.generated.resources.users_profile_no_permissions
import portalvv.shared.generated.resources.users_profile_none
import portalvv.shared.generated.resources.users_profile_permissions
import portalvv.shared.generated.resources.users_profile_remove
import portalvv.shared.generated.resources.users_profile_remove_confirm
import portalvv.shared.generated.resources.users_profile_remove_msg
import portalvv.shared.generated.resources.users_profile_remove_title
import portalvv.shared.generated.resources.users_profiles_empty
import portalvv.shared.generated.resources.users_profiles_title
import portalvv.shared.generated.resources.users_retry
import portalvv.shared.generated.resources.users_save
import portalvv.shared.generated.resources.users_search_placeholder
import portalvv.shared.generated.resources.users_title

private val WeightName = 2f
private val WeightRole = 1.4f
private val WeightCompany = 1.8f
private val WeightEmail = 1.8f
private val WeightUpdatedBy = 1.2f
private val WeightUpdatedAt = 1.2f
private val WeightLastAccess = 1.2f
private val WeightActions = 0.5f

@Composable
fun UsersScreen(onNavigate: (Any) -> Unit = {}) {
    val controller = rememberUsersController()
    val permissions = rememberSessionPermissions()
    val usersKey = PermissionKeys.USERS
    val canCreate = permissions.allows(usersKey, PermissionAction.CREATE)
    val canEdit = permissions.allows(usersKey, PermissionAction.EDIT)
    val canViewDocuments = permissions.allows(PermissionKeys.DOCUMENTS, PermissionAction.VIEW)
    var documentsUser by remember { mutableStateOf<UserAccount?>(null) }

    LaunchedEffect(controller) {
        controller.init()
    }

    AppScrollColumn(
        modifier = Modifier.fillMaxSize(),
        contentPadding = PaddingValues(AppSpacing.space24),
        verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
        footer = { AppFooter() },
    ) {
        Text(
            text = stringResource(Res.string.users_title),
            style = MaterialTheme.typography.headlineMedium,
        )

        controller.errorMessage?.let { message ->
            Surface(
                modifier = Modifier.fillMaxWidth(),
                color = MaterialTheme.colorScheme.errorContainer,
                shape = AppShapes.medium,
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth().padding(AppSpacing.space12),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
                ) {
                    Text(
                        text = message,
                        color = MaterialTheme.colorScheme.onErrorContainer,
                        modifier = Modifier.weight(1f),
                    )
                    AppButton(
                        text = stringResource(Res.string.users_retry),
                        onClick = controller::retry,
                        variant = PortalButtonVariant.Outlined,
                    )
                }
            }
        }

        controller.successMessage?.let { message ->
            Surface(
                modifier = Modifier.fillMaxWidth(),
                color = AppPalette.Success100,
                shape = AppShapes.medium,
            ) {
                Text(
                    text = message,
                    color = AppPalette.Success900,
                    modifier = Modifier.padding(AppSpacing.space12),
                )
            }
        }

        FiltersCard(controller = controller, canCreate = canCreate, canEdit = canEdit)

        if (controller.loading) {
            Box(
                modifier = Modifier.fillMaxWidth().height(240.dp),
                contentAlignment = Alignment.Center,
            ) {
                CircularProgressIndicator()
            }
        } else {
            UsersTable(controller = controller, canEdit = canEdit, canViewDocuments = canViewDocuments) { documentsUser = it }
            AppPagination(
                page = controller.page,
                pageCount = controller.pageCount,
                onPageChange = controller::goToPage,
                modifier = Modifier.align(Alignment.End),
            )
        }
    }

    controller.formMode?.let { mode ->
        UserFormDialog(mode = mode, controller = controller, onNavigate = onNavigate)
    }

    controller.detailsUser?.let { user ->
        UserDetailsDialog(
            user = user,
            profiles = controller.profiles,
            permissions = controller.permissions,
            onDismiss = controller::dismissDetails,
        )
    }

    documentsUser?.let { user ->
        UserDocumentsDialog(user = user, onDismiss = { documentsUser = null })
    }

    controller.deactivateTarget?.let { user ->
        ConfirmDialog(
            title = stringResource(Res.string.users_deactivate_title),
            message = stringResource(Res.string.users_deactivate_msg),
            confirmLabel = stringResource(Res.string.users_deactivate_confirm),
            onConfirm = controller::confirmDeactivate,
            onDismiss = controller::dismissDeactivate,
        )
    }

    if (controller.profilesOpen) {
        ProfilesDialog(
            profiles = controller.profiles,
            permissions = controller.permissions,
            canCreate = canCreate,
            canEdit = canEdit,
            onSave = controller::saveProfile,
            onRemove = controller::removeProfile,
            onDismiss = controller::dismissProfiles,
        )
    }

    if (controller.permissionsOpen) {
        PermissionsDialog(
            permissions = controller.permissions,
            profiles = controller.profiles,
            users = controller.users,
            canCreate = canCreate,
            canEdit = canEdit,
            onCreate = controller::savePermission,
            onRename = controller::renamePermission,
            onRemove = controller::deletePermission,
            onDismiss = controller::dismissPermissions,
        )
    }

    if (controller.importOpen) {
        UserImportDialog(
            profiles = controller.profiles,
            importing = controller.importing,
            error = controller.importError,
            result = controller.importResult,
            onImport = controller::importUsers,
            onPreview = controller::previewImport,
            onDismiss = controller::dismissImport,
        )
    }
}

@Composable
private fun FiltersCard(
    controller: UsersController,
    canCreate: Boolean,
    canEdit: Boolean,
) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space12),
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space16),
            ) {
                AppTextField(
                    value = controller.query,
                    onValueChange = controller::updateQuery,
                    placeholder = stringResource(Res.string.users_search_placeholder),
                    leadingIcon = { Icon(Lucide.Search, contentDescription = null) },
                    modifier = Modifier.weight(1f),
                )
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
                ) {
                    Switch(checked = controller.onlyActive, onCheckedChange = controller::updateOnlyActive)
                    Text(
                        text = stringResource(Res.string.users_only_active),
                        style = MaterialTheme.typography.bodyMedium,
                    )
                }
            }
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
            ) {
                if (canCreate || canEdit) {
                    AppButton(
                        text = stringResource(Res.string.users_manage_permissions),
                        onClick = controller::openPermissions,
                        variant = PortalButtonVariant.Secondary,
                        leadingIcon = Lucide.KeyRound,
                    )
                    AppButton(
                        text = stringResource(Res.string.users_manage_profiles),
                        onClick = controller::openProfiles,
                        variant = PortalButtonVariant.Secondary,
                        leadingIcon = Lucide.ShieldCheck,
                    )
                }
                AppButton(
                    text = stringResource(Res.string.users_export),
                    onClick = {},
                    variant = PortalButtonVariant.Outlined,
                    leadingIcon = Lucide.Download,
                )
                if (canCreate) {
                    AppButton(
                        text = stringResource(Res.string.users_import),
                        onClick = controller::openImport,
                        variant = PortalButtonVariant.Secondary,
                        leadingIcon = Lucide.Upload,
                    )
                    AppButton(
                        text = stringResource(Res.string.users_add),
                        onClick = controller::openAdd,
                        leadingIcon = Lucide.UserPlus,
                    )
                }
            }
        }
    }
}

@Composable
private fun UsersTable(
    controller: UsersController,
    canEdit: Boolean,
    canViewDocuments: Boolean,
    onDocuments: (UserAccount) -> Unit,
) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Column(modifier = Modifier.fillMaxWidth()) {
            UsersHeaderRow()
            HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)
            if (controller.paged.isEmpty()) {
                EmptyState(message = stringResource(Res.string.users_empty))
            } else {
                controller.paged.forEachIndexed { index, user ->
                    UserRow(user = user, controller = controller, canEdit = canEdit, canViewDocuments = canViewDocuments, onDocuments = onDocuments)
                    if (index < controller.paged.lastIndex) {
                        HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)
                    }
                }
            }
        }
    }
}

@Composable
private fun UsersHeaderRow() {
    Row(
        modifier = Modifier.fillMaxWidth().padding(horizontal = AppSpacing.space16, vertical = AppSpacing.space12),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
    ) {
        HeaderCell(stringResource(Res.string.users_col_full_name), WeightName)
        HeaderCell(stringResource(Res.string.users_col_company), WeightCompany)
        HeaderCell(stringResource(Res.string.users_col_role), WeightRole)
        HeaderCell(stringResource(Res.string.users_col_email), WeightEmail)
        HeaderCell(stringResource(Res.string.users_col_updated_by), WeightUpdatedBy)
        HeaderCell(stringResource(Res.string.users_col_updated_at), WeightUpdatedAt)
        HeaderCell(stringResource(Res.string.users_col_last_access), WeightLastAccess)
        HeaderCell(stringResource(Res.string.users_col_actions), WeightActions)
    }
}

@Composable
private fun RowScope.HeaderCell(
    text: String,
    weight: Float,
) {
    Text(
        text = text,
        style = MaterialTheme.typography.labelMedium,
        color = MaterialTheme.colorScheme.onSurfaceVariant,
        maxLines = 1,
        overflow = TextOverflow.Ellipsis,
        modifier = Modifier.weight(weight),
    )
}

@Composable
private fun UserRow(
    user: UserAccount,
    controller: UsersController,
    canEdit: Boolean,
    canViewDocuments: Boolean,
    onDocuments: (UserAccount) -> Unit,
) {
    val muted = !user.active
    val rowColor = if (muted) MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.4f) else Color.Transparent
    Row(
        modifier =
            Modifier
                .fillMaxWidth()
                .background(rowColor)
                .padding(horizontal = AppSpacing.space16, vertical = AppSpacing.space12),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
    ) {
        Row(
            modifier = Modifier.weight(WeightName),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
        ) {
            AppTooltipText(
                text = user.fullName,
                style = MaterialTheme.typography.bodyMedium,
                color = if (muted) MaterialTheme.colorScheme.onSurfaceVariant else MaterialTheme.colorScheme.onSurface,
                modifier = Modifier.weight(1f, fill = false),
            )
            if (muted) {
                AppBadge(
                    text = stringResource(Res.string.users_inactive),
                    containerColor = AppPalette.Neutral200,
                    contentColor = AppPalette.Neutral900,
                )
            }
        }
        BodyCell(
            text = companyNamesLabel(user.companyNames),
            weight = WeightCompany,
            muted = muted,
            tooltipText = user.companyNames.takeIf { it.size > 2 }?.joinToString("\n"),
        )
        BodyCell(user.cargo, WeightRole, muted)
        BodyCell(user.email, WeightEmail, muted)
        BodyCell(user.updatedBy, WeightUpdatedBy, muted)
        BodyCell(user.updatedAt, WeightUpdatedAt, muted)
        BodyCell(user.lastAccess.ifBlank { stringResource(Res.string.users_never) }, WeightLastAccess, muted)
        Box(modifier = Modifier.weight(WeightActions)) {
            UserActionsMenu(user = user, controller = controller, canEdit = canEdit, canViewDocuments = canViewDocuments, onDocuments = onDocuments)
        }
    }
}

@Composable
private fun companyNamesLabel(names: List<String>): String =
    when {
        names.isEmpty() -> stringResource(Res.string.users_none)
        names.size <= 2 -> names.joinToString(", ")
        else -> "${names[0]}, ${names[1]} ${stringResource(Res.string.users_more_names, names.size - 2)}"
    }

@Composable
private fun RowScope.BodyCell(
    text: String,
    weight: Float,
    muted: Boolean = false,
    tooltipText: String? = null,
) {
    AppTooltipText(
        text = text,
        style = MaterialTheme.typography.bodyMedium,
        color =
            if (muted) {
                MaterialTheme.colorScheme.onSurfaceVariant
            } else {
                MaterialTheme.colorScheme.onSurface
            },
        modifier = Modifier.weight(weight),
        tooltipText = tooltipText,
    )
}

@Composable
private fun UserActionsMenu(
    user: UserAccount,
    controller: UsersController,
    canEdit: Boolean,
    canViewDocuments: Boolean,
    onDocuments: (UserAccount) -> Unit,
) {
    var expanded by remember { mutableStateOf(false) }
    Box {
        IconButton(
            onClick = { expanded = true },
            modifier = Modifier.size(24.dp),
        ) {
            Icon(
                imageVector = Lucide.EllipsisVertical,
                contentDescription = null,
                tint = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }
        DropdownMenu(expanded = expanded, onDismissRequest = { expanded = false }) {
            DropdownMenuItem(
                text = { Text(stringResource(Res.string.users_action_details)) },
                leadingIcon = { Icon(Lucide.Eye, contentDescription = null) },
                onClick = {
                    expanded = false
                    controller.openDetails(user)
                },
            )
            if (canViewDocuments) {
                DropdownMenuItem(
                    text = { Text("Documentos") },
                    leadingIcon = { Icon(Lucide.Folder, contentDescription = null) },
                    onClick = {
                        expanded = false
                        onDocuments(user)
                    },
                )
            }
            if (canEdit) {
                if (user.active) {
                    DropdownMenuItem(
                        text = { Text(stringResource(Res.string.users_action_edit)) },
                        leadingIcon = { Icon(Lucide.Pencil, contentDescription = null) },
                        onClick = {
                            expanded = false
                            controller.openEdit(user)
                        },
                    )
                    DropdownMenuItem(
                        text = { Text(stringResource(Res.string.users_action_deactivate)) },
                        leadingIcon = { Icon(Lucide.Ban, contentDescription = null) },
                        onClick = {
                            expanded = false
                            controller.requestDeactivate(user)
                        },
                    )
                } else {
                    DropdownMenuItem(
                        text = { Text(stringResource(Res.string.users_action_activate)) },
                        leadingIcon = { Icon(Lucide.Check, contentDescription = null) },
                        onClick = {
                            expanded = false
                            controller.activate(user)
                        },
                    )
                }
            }
        }
    }
}

@Composable
private fun UserFormDialog(
    mode: UserFormMode,
    controller: UsersController,
    onNavigate: (Any) -> Unit,
) {
    val noneLabel = stringResource(Res.string.users_profile_none)
    val profileOptions = listOf(noneLabel) + controller.profiles.map { it.name }
    val profileIdByName = controller.profiles.associateBy({ it.name }, { it.id })
    val selectedProfile =
        controller.profiles.firstOrNull { it.id == controller.formProfileId }?.name ?: noneLabel
    AppModalCard(
        title =
            stringResource(
                if (mode == UserFormMode.Add) Res.string.users_form_add_title else Res.string.users_form_edit_title,
            ),
        onDismiss = controller::dismissForm,
    ) {
        AppTextField(
            value = controller.formFullName,
            onValueChange = { controller.formFullName = it },
            label = stringResource(Res.string.users_field_full_name),
            modifier = Modifier.fillMaxWidth(),
        )
        AppTextField(
            value = controller.formCargo,
            onValueChange = { controller.formCargo = it },
            label = stringResource(Res.string.users_field_role),
            modifier = Modifier.fillMaxWidth(),
        )
        AppTextField(
            value = controller.formSector,
            onValueChange = { controller.formSector = it },
            label = stringResource(Res.string.users_field_sector),
            modifier = Modifier.fillMaxWidth(),
        )
        AppTextField(
            value = controller.formPhone,
            onValueChange = controller::updatePhone,
            label = stringResource(Res.string.users_field_phone),
            modifier = Modifier.fillMaxWidth(),
        )
        AppTextField(
            value = controller.formEmail,
            onValueChange = { controller.formEmail = it },
            label = stringResource(Res.string.users_field_email),
            modifier = Modifier.fillMaxWidth(),
        )
        if (mode == UserFormMode.Add) {
            AppTextField(
                value = controller.formPassword,
                onValueChange = { controller.formPassword = it },
                label = "Senha inicial (mínimo 8 caracteres)",
                modifier = Modifier.fillMaxWidth(),
            )
        }
        if (mode == UserFormMode.Edit) {
            AppTextField(
                value = controller.formEditPassword,
                onValueChange = { controller.formEditPassword = it },
                label = stringResource(Res.string.users_field_new_password),
                modifier = Modifier.fillMaxWidth(),
                isError = controller.formEditPassword.isNotBlank() && controller.formEditPassword.length < 8,
            )
        }
        Text(
            text = stringResource(Res.string.users_field_profile),
            style = MaterialTheme.typography.labelMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        SearchableSelect(
            leadingIcon = Lucide.UserRound,
            options = profileOptions,
            selected = selectedProfile,
            onSelect = { label -> controller.selectProfile(if (label == noneLabel) null else profileIdByName[label]) },
            modifier = Modifier.fillMaxWidth(),
            underlined = true,
        )
        Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
            Text(
                text = stringResource(Res.string.users_field_permissions),
                style = MaterialTheme.typography.labelMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            controller.permissions.forEach { permission ->
                PermissionActionsRow(
                    label = permission.id,
                    selectedActions = controller.formPermissions[permission.id].orEmpty(),
                    onToggle = { action -> controller.togglePermission(permission.id, action) },
                )
            }
        }
        if (mode == UserFormMode.Edit) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(AppSpacing.space4),
            ) {
                Text(
                    text = stringResource(Res.string.users_company_hint),
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                    textAlign = TextAlign.Center,
                )
                AppButton(
                    text = stringResource(Res.string.users_go_to_org_chart),
                    onClick = {
                        controller.dismissForm()
                        onNavigate(OrgChartRoute)
                    },
                    variant = PortalButtonVariant.Text,
                )
            }
        }
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(
                text = stringResource(Res.string.users_cancel),
                onClick = controller::dismissForm,
                variant = PortalButtonVariant.Text,
            )
            AppButton(
                text = stringResource(Res.string.users_save),
                onClick = controller::submitForm,
                enabled = controller.isFormConfirmEnabled,
                variant = PortalButtonVariant.Filled,
            )
        }
    }
}

@Composable
private fun PermissionActionsRow(
    label: String,
    selectedActions: Set<PermissionAction>,
    onToggle: (PermissionAction) -> Unit,
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
    ) {
        Text(
            text = label,
            style = MaterialTheme.typography.bodyMedium,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis,
            modifier = Modifier.weight(1f),
        )
        PermissionAction.entries.forEach { action ->
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.none),
            ) {
                Checkbox(
                    checked = action in selectedActions,
                    onCheckedChange = { onToggle(action) },
                )
                Text(
                    text = action.label(),
                    style = MaterialTheme.typography.labelSmall,
                )
            }
        }
    }
}

@Composable
private fun UserDetailsDialog(
    user: UserAccount,
    profiles: List<UserProfile>,
    permissions: List<Permission>,
    onDismiss: () -> Unit,
) {
    val none = stringResource(Res.string.users_none)
    AppModalCard(
        title = stringResource(Res.string.users_details_title),
        onDismiss = onDismiss,
    ) {
        DetailRow(stringResource(Res.string.users_field_full_name), user.fullName)
        DetailRow(stringResource(Res.string.users_field_role), user.cargo.ifBlank { none })
        DetailRow(stringResource(Res.string.users_col_company), user.companyNames.ifEmpty { listOf(none) }.joinToString(", "))
        DetailRow(stringResource(Res.string.users_field_sector), user.sector.ifBlank { none })
        DetailRow(stringResource(Res.string.users_field_phone), user.phone.ifBlank { none })
        DetailRow(stringResource(Res.string.users_field_email), user.email)
        DetailRow(
            stringResource(Res.string.users_field_profile),
            profiles.firstOrNull { it.id == user.profileId }?.name ?: none,
        )
        DetailRow(stringResource(Res.string.users_field_permissions), permissionsLabel(permissions, user.permissions))
        DetailRow(stringResource(Res.string.users_col_updated_by), user.updatedBy)
        DetailRow(stringResource(Res.string.users_col_updated_at), user.updatedAt)
        DetailRow(
            stringResource(Res.string.users_col_last_access),
            user.lastAccess.ifBlank { stringResource(Res.string.users_never) },
        )
    }
}

@Composable
private fun DetailRow(
    label: String,
    value: String,
) {
    Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
        Text(
            text = label,
            style = MaterialTheme.typography.labelMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Text(
            text = value,
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurface,
        )
    }
}

@Composable
private fun ConfirmDialog(
    title: String,
    message: String,
    confirmLabel: String,
    onConfirm: () -> Unit,
    onDismiss: () -> Unit,
) {
    AppModalCard(title = title, onDismiss = onDismiss) {
        Text(
            text = message,
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(
                text = stringResource(Res.string.users_cancel),
                onClick = onDismiss,
                variant = PortalButtonVariant.Text,
            )
            AppButton(
                text = confirmLabel,
                onClick = onConfirm,
                variant = PortalButtonVariant.Filled,
            )
        }
    }
}

@Composable
private fun ProfilesDialog(
    profiles: List<UserProfile>,
    permissions: List<Permission>,
    canCreate: Boolean,
    canEdit: Boolean,
    onSave: (UserProfile) -> Unit,
    onRemove: (String) -> Unit,
    onDismiss: () -> Unit,
) {
    var editing by remember { mutableStateOf<UserProfile?>(null) }
    var creating by remember { mutableStateOf(false) }
    var removeTarget by remember { mutableStateOf<UserProfile?>(null) }

    if (creating || editing != null) {
        ProfileFormDialog(
            profile = editing,
            permissions = permissions,
            newProfileId = nextProfileId(profiles),
            onSave = { profile ->
                onSave(profile)
                creating = false
                editing = null
            },
            onCancel = {
                creating = false
                editing = null
            },
        )
    } else {
        AppModalCard(title = stringResource(Res.string.users_profiles_title), onDismiss = onDismiss) {
            if (canCreate) {
                AppButton(
                    text = stringResource(Res.string.users_profile_new),
                    onClick = { creating = true },
                    variant = PortalButtonVariant.Secondary,
                    leadingIcon = Lucide.Plus,
                    modifier = Modifier.fillMaxWidth(),
                )
            }
            if (profiles.isEmpty()) {
                Text(
                    text = stringResource(Res.string.users_profiles_empty),
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            } else {
                profiles.forEach { profile ->
                    ProfileRow(
                        profile = profile,
                        permissions = permissions,
                        canEdit = canEdit,
                        onEdit = { editing = profile },
                        onRemove = { removeTarget = profile },
                    )
                }
            }
        }
    }

    removeTarget?.let { profile ->
        ConfirmDialog(
            title = stringResource(Res.string.users_profile_remove_title),
            message = stringResource(Res.string.users_profile_remove_msg, profile.name),
            confirmLabel = stringResource(Res.string.users_profile_remove_confirm),
            onConfirm = {
                onRemove(profile.id)
                removeTarget = null
            },
            onDismiss = { removeTarget = null },
        )
    }
}

@Composable
private fun ProfileRow(
    profile: UserProfile,
    permissions: List<Permission>,
    canEdit: Boolean,
    onEdit: () -> Unit,
    onRemove: () -> Unit,
) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.medium,
        color = MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.3f),
    ) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space12),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
        ) {
            Column(
                modifier = Modifier.weight(1f),
                verticalArrangement = Arrangement.spacedBy(AppSpacing.space4),
            ) {
                Text(
                    text = profile.name,
                    style = MaterialTheme.typography.titleSmall,
                    color = MaterialTheme.colorScheme.onSurface,
                )
                Text(
                    text = permissionsLabel(permissions, profile.permissions),
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            }
            if (canEdit) {
                IconButton(onClick = onEdit) {
                    Icon(
                        imageVector = Lucide.Pencil,
                        contentDescription = stringResource(Res.string.users_action_edit),
                        tint = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                }
                IconButton(onClick = onRemove) {
                    Icon(
                        imageVector = Lucide.Trash2,
                        contentDescription = stringResource(Res.string.users_profile_remove),
                        tint = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                }
            }
        }
    }
}

@Composable
private fun ProfileFormDialog(
    profile: UserProfile?,
    permissions: List<Permission>,
    newProfileId: String,
    onSave: (UserProfile) -> Unit,
    onCancel: () -> Unit,
) {
    var name by remember { mutableStateOf(profile?.name ?: "") }
    var selectedPermissions by remember {
        mutableStateOf(profile?.permissions ?: emptyMap<String, Set<PermissionAction>>())
    }
    AppModalCard(
        title =
            stringResource(
                if (profile == null) Res.string.users_profile_form_add_title else Res.string.users_profile_form_edit_title,
            ),
        onDismiss = onCancel,
    ) {
        AppTextField(
            value = name,
            onValueChange = { name = it },
            label = stringResource(Res.string.users_profile_name),
            modifier = Modifier.fillMaxWidth(),
        )
        Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
            Text(
                text = stringResource(Res.string.users_profile_permissions),
                style = MaterialTheme.typography.labelMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            permissions.forEach { permission ->
                PermissionActionsRow(
                    label = permission.id,
                    selectedActions = selectedPermissions[permission.id].orEmpty(),
                    onToggle = { action -> selectedPermissions = selectedPermissions.toggle(permission.id, action) },
                )
            }
        }
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(
                text = stringResource(Res.string.users_cancel),
                onClick = onCancel,
                variant = PortalButtonVariant.Text,
            )
            AppButton(
                text = stringResource(Res.string.users_save),
                onClick = {
                    onSave(
                        UserProfile(
                            id = profile?.id ?: newProfileId,
                            name = name.trim(),
                            permissions = selectedPermissions,
                        ),
                    )
                },
                enabled = name.isNotBlank(),
                variant = PortalButtonVariant.Filled,
            )
        }
    }
}

@Composable
private fun PermissionsDialog(
    permissions: List<Permission>,
    profiles: List<UserProfile>,
    users: List<UserAccount>,
    canCreate: Boolean,
    canEdit: Boolean,
    onCreate: (String, Map<String, Set<PermissionAction>>) -> Unit,
    onRename: (String, String) -> Unit,
    onRemove: (String) -> Unit,
    onDismiss: () -> Unit,
) {
    var creating by remember { mutableStateOf(false) }
    var editing by remember { mutableStateOf<Permission?>(null) }
    var removeTarget by remember { mutableStateOf<Permission?>(null) }
    val usedIds =
        remember(profiles, users) {
            profiles.flatMap { it.permissions.keys }.toSet() + users.flatMap { it.permissions.keys }.toSet()
        }

    if (creating || editing != null) {
        PermissionFormDialog(
            permission = editing,
            profiles = profiles,
            onSave = { name, assignments ->
                val target = editing
                if (target == null) {
                    onCreate(name, assignments)
                } else {
                    onRename(target.id, name)
                }
                creating = false
                editing = null
            },
            onCancel = {
                creating = false
                editing = null
            },
        )
    } else {
        AppModalCard(title = stringResource(Res.string.users_permissions_title), onDismiss = onDismiss) {
            if (canCreate) {
                AppButton(
                    text = stringResource(Res.string.users_permission_new),
                    onClick = { creating = true },
                    variant = PortalButtonVariant.Secondary,
                    leadingIcon = Lucide.Plus,
                    modifier = Modifier.fillMaxWidth(),
                )
            }
            if (permissions.isEmpty()) {
                Text(
                    text = stringResource(Res.string.users_permissions_empty),
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            } else {
                permissions.forEach { permission ->
                    PermissionRow(
                        permission = permission,
                        canManage = canEdit && permission.id !in usedIds,
                        onEdit = { editing = permission },
                        onRemove = { removeTarget = permission },
                    )
                }
            }
        }
    }

    removeTarget?.let { permission ->
        ConfirmDialog(
            title = stringResource(Res.string.users_permission_remove_title),
            message = stringResource(Res.string.users_permission_remove_msg, permission.id),
            confirmLabel = stringResource(Res.string.users_permission_remove_confirm),
            onConfirm = {
                onRemove(permission.id)
                removeTarget = null
            },
            onDismiss = { removeTarget = null },
        )
    }
}

@Composable
private fun PermissionRow(
    permission: Permission,
    canManage: Boolean,
    onEdit: () -> Unit,
    onRemove: () -> Unit,
) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.medium,
        color = MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.3f),
    ) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space12),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
        ) {
            Icon(
                imageVector = Lucide.KeyRound,
                contentDescription = null,
                tint = MaterialTheme.colorScheme.onSurfaceVariant,
                modifier = Modifier.size(18.dp),
            )
            Text(
                text = permission.id,
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurface,
                modifier = Modifier.weight(1f),
            )
            if (canManage) {
                IconButton(onClick = onEdit) {
                    Icon(
                        imageVector = Lucide.Pencil,
                        contentDescription = stringResource(Res.string.users_action_edit),
                        tint = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                }
                IconButton(onClick = onRemove) {
                    Icon(
                        imageVector = Lucide.Trash2,
                        contentDescription = stringResource(Res.string.users_permission_remove),
                        tint = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                }
            }
        }
    }
}

@Composable
private fun PermissionFormDialog(
    permission: Permission?,
    profiles: List<UserProfile>,
    onSave: (String, Map<String, Set<PermissionAction>>) -> Unit,
    onCancel: () -> Unit,
) {
    var code by remember { mutableStateOf(permission?.id ?: "") }
    var assignments by remember { mutableStateOf<Map<String, Set<PermissionAction>>>(emptyMap()) }
    AppModalCard(
        title =
            stringResource(
                if (permission == null) Res.string.users_permission_new else Res.string.users_permission_edit_title,
            ),
        onDismiss = onCancel,
    ) {
        AppTextField(
            value = code,
            onValueChange = { code = it },
            label = stringResource(Res.string.users_permission_code),
            modifier = Modifier.fillMaxWidth(),
        )
        if (permission == null) {
            Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
                Text(
                    text = stringResource(Res.string.users_permission_profiles),
                    style = MaterialTheme.typography.labelMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
                if (profiles.isEmpty()) {
                    Text(
                        text = stringResource(Res.string.users_profiles_empty),
                        style = MaterialTheme.typography.bodyMedium,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                } else {
                    profiles.forEach { profile ->
                        PermissionActionsRow(
                            label = profile.name,
                            selectedActions = assignments[profile.id].orEmpty(),
                            onToggle = { action -> assignments = assignments.toggle(profile.id, action) },
                        )
                    }
                }
            }
        }
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(
                text = stringResource(Res.string.users_cancel),
                onClick = onCancel,
                variant = PortalButtonVariant.Text,
            )
            AppButton(
                text = stringResource(Res.string.users_save),
                onClick = { onSave(code.trim(), assignments) },
                enabled = code.isNotBlank(),
                variant = PortalButtonVariant.Filled,
            )
        }
    }
}

@Composable
private fun permissionsLabel(
    all: List<Permission>,
    assigned: Map<String, Set<PermissionAction>>,
): String {
    val parts =
        all
            .filter { assigned[it.id]?.isNotEmpty() == true }
            .map { permission -> "${permission.id} (${actionsLabel(assigned.getValue(permission.id))})" }
    return if (parts.isEmpty()) stringResource(Res.string.users_profile_no_permissions) else parts.joinToString(", ")
}

@Composable
private fun actionsLabel(actions: Set<PermissionAction>): String {
    val labels = PermissionAction.entries.filter { it in actions }.map { it.label() }
    return labels.joinToString(", ")
}

@Composable
private fun PermissionAction.label(): String =
    when (this) {
        PermissionAction.CREATE -> stringResource(Res.string.users_action_create)
        PermissionAction.EDIT -> stringResource(Res.string.users_action_edit)
        PermissionAction.VIEW -> stringResource(Res.string.users_action_view)
    }

private fun Map<String, Set<PermissionAction>>.toggle(
    permissionId: String,
    action: PermissionAction,
): Map<String, Set<PermissionAction>> {
    val current = this[permissionId].orEmpty()
    val updated = if (action in current) current - action else current + action
    return if (updated.isEmpty()) this - permissionId else this + (permissionId to updated)
}

private fun nextProfileId(profiles: List<UserProfile>): String {
    var index = profiles.size + 1
    while (profiles.any { it.id == "p-novo-$index" }) {
        index++
    }
    return "p-novo-$index"
}
